import React from 'react';

import { OneColumn } from 'components/page';
import { PedidoRealizadoGrid } from 'pages/compra/pedido-realizado/components/templates/PedidoRealizadoGrid';
import { PedidoRealizadoListFilter } from 'pages/compra/pedido-realizado/components/templates/PedidoRealizadoListFilter';
import { PedidoRealizadoRelatorio } from 'pages/compra/pedido-realizado/components';

export function PedidoRealizadoListComp() {
    return (
        <OneColumn title="Consulta de Pedidos" goBackButton createButton={false}>
            <PedidoRealizadoListFilter />

            <PedidoRealizadoRelatorio />

            <PedidoRealizadoGrid />
        </OneColumn>
    );
}
